// extracted by mini-css-extract-plugin
module.exports = {"container":"received_container__3_0-1","header":"received_header__3GMFN","body":"received_body__3B_PT"};